import state from './moduleRechercheState.js'
import mutations from './moduleRechercheMutations.js'
import actions from './moduleRechercheActions.js'
import getters from './moduleRechercheGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
